import { render, staticRenderFns } from "./TableFilhos.vue?vue&type=template&id=89f7eb18"
import script from "./TableFilhos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableFilhos.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports